export function getBackendUrl() {
  const allowOverride = import.meta.env.VITE_ALLOW_BACKEND_OVERRIDE === 'true';
  const defaultUrl = import.meta.env.VITE_BACKEND_URL;
  const queryParamUrl = getQueryParam('backend-url');

  return allowOverride && queryParamUrl ? queryParamUrl : defaultUrl;
}

function getQueryParam(param: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
